<div class="content-container extended py-5 landing-market-watch-section">
  <div class="container-fluid w-100 px-2 px-lg-4 landing-market-watch-container">
    <div class="row px-0 pb-3">
      <p class="px-4 fs-md-26 fs-mb-24 lh-sm fw-bolder text-center h-mb">
        Top Auction Results of {{ displayYear }}
      </p>
    </div>
    <div class="row px-0 pb-2" *ngIf="loading">
      <p class="text-center text-muted">Loading auction results…</p>
    </div>
    <div class="row px-0 pb-2" *ngIf="loadError && !loading">
      <p class="text-center text-muted">{{ loadError }}</p>
    </div>
    <div class="px-0 row landing-market-watch-tables">
      <div class="col-12 col-lg-6 landing-market-watch-col">
        <div class="landing-market-watch-table-wrap pe-0 pe-lg-2">
          <table class="table table-striped mb-0 w-100">
            <tbody>
              <tr
                *ngFor="let row of topThisYear.slice(0, 10); let i = index"
                class="align-middle"
              >
                <td
                  class="fs-md-22 fs-mb-18 fw-normal text-center pe-1 d-none d-lg-table-cell"
                  style="color: #0a6077"
                >
                  {{ i + 1 | fixedDigit : 2 }}
                </td>
                <td class="px-0 landing-mw-plate-td">
                  <pla-plate
                    [rawPlate]="row.formattedRegistration"
                    [showPrice]="false"
                    [changeHover]="false"
                    [mobileSmall]="true"
                    [customClass]="'flat shaded'"
                    [plateSize]="'ns-s'"
                    [smallPlate]="false"
                    [clickThrough]="false"
                    [showPercentage]="false"
                    [noMargin]="true"
                    [termFirst]="false"
                    [showIndex]="false"
                  ></pla-plate>
                </td>
                <td class="text-center px-0 fs-md-14">{{
                  SellerNameMapper(row.seller, true)
                }}</td>
                <td class="text-center px-0 fs-md-14">
                  {{ row.sold_date | date : "MMM YYYY" }}
                </td>
                <td class="text-center">
                  <strong>{{
                    row.sold_price / 100 | currency : "GBP" : "symbol" : "1.0-0"
                  }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-12 col-lg-6 landing-market-watch-col">
        <div class="landing-market-watch-table-wrap ps-0 ps-lg-2">
          <table class="table table-striped mb-0 w-100">
            <tbody>
              <tr
                *ngFor="let row of topThisYear.slice(10, 20); let i = index"
                class="align-middle"
              >
                <td
                  class="fs-md-22 fs-mb-18 fw-normal text-center pe-1 d-none d-lg-table-cell"
                  style="color: #0a6077"
                >
                  {{ i + 11 | fixedDigit : 2 }}
                </td>
                <td class="px-0 landing-mw-plate-td">
                  <pla-plate
                    [rawPlate]="row.formattedRegistration"
                    [showPrice]="false"
                    [changeHover]="false"
                    [mobileSmall]="true"
                    [customClass]="'flat shaded'"
                    [plateSize]="'ns-s'"
                    [smallPlate]="false"
                    [clickThrough]="false"
                    [showPercentage]="false"
                    [noMargin]="true"
                    [termFirst]="false"
                    [showIndex]="false"
                  ></pla-plate>
                </td>
                <td class="text-center px-0 fs-md-14">{{
                  SellerNameMapper(row.seller, true)
                }}</td>
                <td class="text-center px-0 fs-md-14">
                  {{ row.sold_date | date : "MMM YYYY" }}
                </td>
                <td class="text-center">
                  <strong>{{
                    row.sold_price / 100 | currency : "GBP" : "symbol" : "1.0-0"
                  }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
